import React from 'react';
import { ArrowLeft, Scale, FileText, Shield, CheckCircle, Download, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';

const Normatividad = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Header */}
      <div className="bg-gradient-to-r from-[#0b742f] to-[#085a24] text-white py-16">
        <div className="max-w-7xl mx-auto px-6">
          <Link 
            to="/maestria" 
            className="inline-flex items-center gap-2 text-green-200 hover:text-white mb-6 transition-colors duration-300"
          >
            <ArrowLeft className="w-5 h-5" />
            Volver a Maestría
          </Link>
          <div className="flex items-center gap-4">
            <div className="bg-white/10 backdrop-blur-sm p-4 rounded-xl">
              <Scale className="w-12 h-12" />
            </div>
            <div>
              <h1 className="text-4xl md:text-5xl font-bold mb-2">Normatividad</h1>
              <p className="text-xl text-green-100">
                Marco normativo y reglamentario del CENID
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16">
        {/* Acuerdo del Comité Técnico */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center gap-3 mb-8">
              <Shield className="w-8 h-8 text-[#0b742f]" />
              <h2 className="text-3xl font-bold text-gray-900">ACUERDO PARA LA CREACIÓN DEL COMITÉ TÉCNICO PARA LA INTERPRETACIÓN Y APLICACIÓN DE LA NORMATIVIDAD DE LA INSTITUCIÓN CENID</h2>
            </div>
            <div className="prose prose-lg max-w-none text-gray-700">
              <p className="text-lg leading-relaxed mb-6">
                Francisco Santillán Campos, Rector del Centro de Estudios e Investigaciones para 
                el Desarrollo Docente CENID, con fundamento en lo dispuesto en el documento de 
                creación de la Institución y:
              </p>

              <div className="bg-green-50 rounded-lg p-6 mb-8">
                <h3 className="text-xl font-bold text-[#0b742f] mb-4">CONSIDERANDO</h3>
                <div className="space-y-4">
                  <p className="text-gray-700 leading-relaxed">
                    Que el Consejo institucional, en su 1ª Sesión ordinaria del 6 de septiembre de 
                    2015, aprobó el Reglamento Escolar del Centro de Estudios e Investigaciones para 
                    el Desarrollo Docente CENID.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Que el Centro de Estudios e Investigaciones para el Desarrollo Docente se 
                    encuentra plenamente comprometida con el desarrollo de una política de transparencia 
                    en la aplicación de las normas escolares que ha establecido, con el propósito de 
                    llevar a cabo una cultura institucional integral que asegure el respeto de los 
                    derechos de sus estudiantes, mediante un trato digno.
                  </p>
                  <p className="text-gray-700 leading-relaxed">
                    Que en términos de lo dispuesto en el artículo 8 en el documento de creación de 
                    la Institución, el Rector cuenta con facultades para establecer, cuando así lo 
                    considere conveniente, Comités Técnicos que coadyuven al buen funcionamiento de 
                    la Institución, por lo que de conformidad con lo expuesto y fundado, he tenido a 
                    bien expedir el siguiente:
                  </p>
                </div>
              </div>

              <div className="bg-blue-50 rounded-lg p-6 mb-8">
                <h3 className="text-xl font-bold text-blue-700 mb-4">
                  ACUERDO POR EL QUE SE CREA EL COMITÉ TÉCNICO DE INTERPRETACIÓN Y APLICACIÓN DE LA NORMATIVIDAD INSTITUCIONAL
                </h3>
              </div>
            </div>
          </div>
        </section>

        {/* Artículos del Acuerdo */}
        <section className="mb-16">
          <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-2xl shadow-xl p-8 md:p-12 border border-amber-100">
            <div className="flex items-center gap-3 mb-8">
              <FileText className="w-10 h-10 text-amber-600" />
              <h2 className="text-3xl font-bold text-gray-900">Artículos del Acuerdo</h2>
            </div>

            <div className="space-y-8">
              {/* Artículo 1 */}
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold text-amber-700 mb-4">Artículo 1.</h3>
                <p className="text-gray-700 leading-relaxed">
                  Se crea el Comité Técnico de Interpretación y Aplicación de la Normatividad Institucional, 
                  con el objeto de promover y fomentar el cumplimiento de la aplicación y/o en su caso, de la 
                  interpretación de la normatividad interna que rige a la Institución, contribuyendo a la cultura 
                  de la legalidad, transparencia, flexibilidad, igualdad, equidad y no discriminación.
                </p>
              </div>

              {/* Artículo 2 */}
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold text-amber-700 mb-4">Artículo 2.</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Para el cumplimiento de su objeto, el Comité Técnico de Interpretación y Aplicación de la 
                  Normatividad Institucional tendrá las siguientes funciones:
                </p>
                <div className="bg-amber-50 rounded-lg p-4">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">I</span>
                      <span className="text-gray-700">
                        Impulsar, difundir y promover entre la comunidad de la institución, el conocimiento de las normas que rigen el funcionamiento de la Institución
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">II</span>
                      <span className="text-gray-700">
                        Establecer criterios de interpretación jurídica derivado de la aplicación de las disposiciones normativas institucionales
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">III</span>
                      <span className="text-gray-700">
                        Presentar a la Comisión de Normatividad institucional del Consejo institucional, las propuestas que estime pertinentes para actualizar las disposiciones normativas internas
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">IV</span>
                      <span className="text-gray-700">
                        Analizar y en su caso, determinar la aplicación de medidas administrativas a los estudiantes, en los términos previstos en el Reglamento Escolar
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">V</span>
                      <span className="text-gray-700">
                        Conocer de los recursos de reconsideración que presenten los estudiantes por la aplicación de medidas administrativas
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">VI</span>
                      <span className="text-gray-700">
                        Asesorar a los Directores de las Divisiones Académicas en las resoluciones que emitan para la aplicación de medidas administrativas
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">VII</span>
                      <span className="text-gray-700">
                        Las demás que resulten necesarias o que encomiende el Rector
                      </span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Artículo 3 */}
              <div className="bg-white rounded-lg p-6">
                <h3 className="text-xl font-bold text-amber-700 mb-4">Artículo 3.</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  El Comité Técnico de Interpretación y Aplicación de la Normatividad Institucional, estará integrado de la siguiente manera:
                </p>
                <div className="bg-amber-50 rounded-lg p-4">
                  <ul className="space-y-3">
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">I</span>
                      <span className="text-gray-700">
                        El Secretario General, quien lo presidirá, en términos de lo dispuesto en el artículo 14 fracción VIII, del Decreto de creación de la Institución
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">II</span>
                      <span className="text-gray-700">El Coordinador Académico y de Investigación</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">III</span>
                      <span className="text-gray-700">El Coordinador de Extensión, Vinculación y Desarrollo Social</span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">IV</span>
                      <span className="text-gray-700">
                        Los Directores de las Divisiones Académicas, de acuerdo con el asunto y naturaleza académica de que se trate
                      </span>
                    </li>
                    <li className="flex items-start gap-3">
                      <span className="bg-amber-600 text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">V</span>
                      <span className="text-gray-700">
                        El Director de Asuntos Escolares y Apoyo a Estudiantes, quien fungirá como Secretario Técnico del Comité
                      </span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Facultades y Funcionamiento */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-l-4 border-[#0b742f]">
            <div className="flex items-center gap-3 mb-8">
              <Scale className="w-10 h-10 text-[#0b742f]" />
              <h2 className="text-3xl font-bold text-gray-900">Funcionamiento y Facultades del Comité</h2>
            </div>

            <div className="space-y-8">
              {/* Artículo 4 */}
              <div className="bg-green-50 rounded-lg p-6">
                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Artículo 4.</h3>
                <p className="text-gray-700 leading-relaxed">
                  El Comité Técnico de Interpretación y Aplicación de la Normatividad Institucional, sesionará 
                  de manera ordinaria tres veces al año y de manera extraordinaria, cuando por la urgencia de 
                  los asuntos sea necesario y lo convoque para tal efecto el Secretario Técnico.
                </p>
              </div>

              {/* Artículo 5 - Facultades del Presidente */}
              <div className="bg-green-50 rounded-lg p-6">
                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Artículo 5.</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Son facultades del Presidente del Comité Técnico de Interpretación y Aplicación de la 
                  Normatividad Institucional:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">I</span>
                    <span className="text-gray-700">Conocer y opinar sobre las convocatorias que emita el Secretario Técnico</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">II</span>
                    <span className="text-gray-700">Iniciar y clausurar las sesiones y, en su caso, prorrogarlas o suspenderlas por causa justificada</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">III</span>
                    <span className="text-gray-700">Determinar las medidas que estime necesarias para la organización del desarrollo de las sesiones</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">IV</span>
                    <span className="text-gray-700">Moderar el desarrollo de las deliberaciones y debates, y</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">V</span>
                    <span className="text-gray-700">Verificar que se desahoguen los asuntos previstos en el Orden del Día</span>
                  </li>
                </ul>
              </div>

              {/* Artículo 6 - Facultades del Secretario Técnico */}
              <div className="bg-green-50 rounded-lg p-6">
                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Artículo 6.</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Son facultades del Secretario Técnico del Comité Técnico de Interpretación y Aplicación de la 
                  Normatividad Institucional:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">I</span>
                    <span className="text-gray-700">Apoyar al Presidente y a los integrantes del Comité, para el desempeño oportuno de las funciones a su cargo</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">II</span>
                    <span className="text-gray-700">Enviar a los integrantes del Comité la Convocatoria y el Orden del Día correspondientes, así como los documentos de trabajo necesarios, con una antelación de al menos cinco días al desarrollo de la Sesión</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">III</span>
                    <span className="text-gray-700">Levantar y llevar el control de las actas de cada sesión y dar seguimiento al cumplimiento de los acuerdos adoptados</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">IV</span>
                    <span className="text-gray-700">Las demás que le asigne el Rector o que se acuerden por los integrantes del Comité</span>
                  </li>
                </ul>
              </div>

              {/* Artículo 7 - Facultades de los Miembros */}
              <div className="bg-green-50 rounded-lg p-6">
                <h3 className="text-xl font-bold text-[#0b742f] mb-4">Artículo 7.</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Son facultades y obligaciones de los miembros del Comité Técnico de Interpretación y Aplicación 
                  de la Normatividad Institucional:
                </p>
                <ul className="space-y-2">
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">I</span>
                    <span className="text-gray-700">Asistir a las sesiones convocadas</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">II</span>
                    <span className="text-gray-700">Emitir su opinión en los asuntos de su competencia</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">III</span>
                    <span className="text-gray-700">Cumplir con diligencia el desempeño de su encargo</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">IV</span>
                    <span className="text-gray-700">Manejar responsablemente la información a la que tiene acceso</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="bg-[#0b742f] text-white rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5 text-sm font-bold">V</span>
                    <span className="text-gray-700">Las demás que les encomiende el Rector</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Transitorios y Firma */}
        <section className="mb-16">
          <div className="bg-gradient-to-br from-[#0b742f] to-[#085a24] text-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center gap-3 mb-8">
              <FileText className="w-10 h-10 text-[#e87729]" />
              <h2 className="text-3xl font-bold">TRANSITORIOS</h2>
            </div>
            
            <div className="space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h3 className="text-xl font-bold text-green-100 mb-4">Primero.</h3>
                <p className="text-lg leading-relaxed text-white/95">
                  El presente Acuerdo entrará en vigor al día siguiente de su publicación en el Portal de la 
                  en el documento de creación de la Institución.
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                <h3 className="text-xl font-bold text-green-100 mb-4">Segundo.</h3>
                <p className="text-lg leading-relaxed text-white/95">
                  Los asuntos no previstos en el presente Acuerdo serán resueltos por el Rector del Centro 
                  de Estudios e Investigaciones para el Desarrollo Docente. Dado en la Ciudad de Guadalajara, 
                  Jalisco, a los quince días del mes de septiembre de dos mil quince.
                </p>
              </div>

              <div className="text-center mt-8">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
                  <p className="text-xl font-bold text-green-100 mb-2">DR. FRANCISCO SANTILLÁN CAMPOS</p>
                  <p className="text-lg text-white/90">RECTOR</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Documentos Oficiales */}
        <section className="mb-16">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 border-l-4 border-[#e87729]">
            <div className="flex items-center gap-3 mb-8">
              <Download className="w-10 h-10 text-[#e87729]" />
              <h2 className="text-3xl font-bold text-gray-900">Documentos Oficiales</h2>
            </div>

            <div className="grid md:grid-cols-3 gap-6">
              <div className="bg-orange-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-[#e87729] p-3 rounded-lg">
                    <FileText className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="font-bold text-gray-900">Código de Ética del CENID</h3>
                </div>
                <p className="text-gray-700 text-sm mb-4">
                  Documento que establece los principios éticos y valores institucionales.
                </p>
                <a 
                  href="https://www.cenid.org/documentos/codigoetica.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#e87729] hover:text-orange-700 font-semibold"
                >
                  <Download className="w-4 h-4" />
                  Descargar PDF
                </a>
              </div>

              <div className="bg-green-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-[#0b742f] p-3 rounded-lg">
                    <FileText className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="font-bold text-gray-900">Lineamientos del Logo Institucional</h3>
                </div>
                <p className="text-gray-700 text-sm mb-4">
                  Normativa para el uso correcto de la identidad visual del CENID.
                </p>
                <a 
                  href="https://www.cenid.org/documentos/lineamientologo.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#0b742f] hover:text-green-700 font-semibold"
                >
                  <Download className="w-4 h-4" />
                  Descargar PDF
                </a>
              </div>

              <div className="bg-blue-50 rounded-lg p-6 hover:shadow-lg transition-shadow duration-300">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-blue-600 p-3 rounded-lg">
                    <FileText className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="font-bold text-gray-900">Reglamento General</h3>
                </div>
                <p className="text-gray-700 text-sm mb-4">
                  Disposiciones generales que rigen el funcionamiento institucional.
                </p>
                <a 
                  href="https://www.cenid.org/documentos/reglamentogeneral.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold"
                >
                  <Download className="w-4 h-4" />
                  Descargar PDF
                </a>
              </div>
            </div>
          </div>
        </section>

        {/* Enlaces y Recursos */}
        <section>
          <div className="bg-gradient-to-br from-[#0b742f] to-[#085a24] text-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="flex items-center gap-3 mb-8">
              <ExternalLink className="w-10 h-10 text-[#e87729]" />
              <h2 className="text-3xl font-bold">Enlaces y Recursos</h2>
            </div>
            <div className="grid md:grid-cols-2 gap-8">
              <div>
                <h3 className="text-xl font-bold text-green-100 mb-4">Normatividad Interna</h3>
                <div className="space-y-3">
                  <a 
                    href="https://www.cenid.org/postgrados/normatividad" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Página oficial de normatividad</span>
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <Download className="w-4 h-4" />
                    <span>Reglamento Escolar</span>
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <Download className="w-4 h-4" />
                    <span>Manual del Estudiante</span>
                  </a>
                </div>
              </div>
              <div>
                <h3 className="text-xl font-bold text-green-100 mb-4">Marco Legal Externo</h3>
                <div className="space-y-3">
                  <a 
                    href="#" 
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Ley General de Educación</span>
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Lineamientos SEP</span>
                  </a>
                  <a 
                    href="#" 
                    className="flex items-center gap-2 text-green-200 hover:text-white transition-colors duration-300"
                  >
                    <ExternalLink className="w-4 h-4" />
                    <span>Criterios SECIHTI</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Normatividad;